(() => {
  const initialized = new WeakSet();
  const cleanup = new WeakMap();
  const setup = (page) => {
    if (initialized.has(page)) return;
    initialized.add(page);
    const labels = JSON.parse(page.querySelector('[data-tt-labels]').textContent);
    const root = page.dataset.root || '/';
    const offer = page.dataset.offer === 'true';
    const loggedIn = page.dataset.loggedIn === 'true';
    const returning = page.dataset.returning === 'true';
    const baseCode = page.dataset.code.trim();
    let code = baseCode;
    let percent = offer ? 30 : 0;
    const lifetime = new AbortController();
    const cartDialog = page.querySelector('[data-tt-cart]');
    const status = page.querySelector('[data-tt-status]');
    const cartError = page.querySelector('[data-tt-cart-error]');
    const checkoutButton = page.querySelector('[data-tt-checkout]');
    const pendingKey = 'dg-tiktok-checkout:' + location.pathname;
    const money = new Intl.NumberFormat(page.dataset.locale || 'en', {style:'currency', currency:page.dataset.currency || 'USD'});
    let busy = false;
    let cart = null;
    let toastTimer;
    let opener;
    let leaving = false;
    const format = (cents) => money.format(Number(cents) / 100);
    const showError = (node, message) => { node.textContent = message; node.hidden = !message; };
    const toast = (message) => { clearTimeout(toastTimer); status.textContent = message; toastTimer = setTimeout(() => { status.textContent = ''; }, 5000); };
    const updatePrice = (card) => {
      const price = Number(card.dataset.basePrice);
      card.querySelector('[data-tt-price]').textContent = format(Math.round(price * (100 - percent) / 100));
      const original = card.querySelector('[data-tt-original]');
      if (original) original.textContent = format(price);
    };
    const applyOffer = (rate, nextCode) => {
      if (percent === rate && code === nextCode) return;
      percent = rate; code = nextCode;
      const regular = {announcement:labels.sticky_regular, hero_offer:'', shop_offer:labels.shop_picks, strip_offer:labels.secure, offer_explain:labels.expired_offer_explain, faq_first_a:labels.expired_first_faq, sticky_offer:labels.timed_ended, cart_offer_note:labels.cart_regular_note, card_badge:'', hero_terms:labels.hero_regular, shop_note:labels.shop_regular_note, shop_disclosure:labels.cart_regular_note};
      page.querySelectorAll('[data-tt-rate-copy]').forEach(node => {
        const template = labels[node.dataset.ttRateCopy];
        if (template) node.textContent = percent ? template.replaceAll('__PERCENT__', String(percent)) : regular[node.dataset.ttRateCopy] || '';
      });
      page.querySelectorAll('[data-tt-rate-number]').forEach(node => { node.textContent = percent; });
      page.querySelectorAll('[data-tt-code-copy]').forEach(node => { node.textContent = percent ? labels.faq_code_a.replaceAll('__CODE__', code) : labels.expired_code_faq; });
      page.querySelectorAll('[data-tt-only-offer], .tt-product__badge, [data-tt-original]').forEach(node => { node.hidden = !percent; });
      page.querySelectorAll('[data-tt-price-note]').forEach(node => { node.textContent = percent ? labels.first_price : labels.regular_price; });
      page.querySelectorAll('[data-tt-product]').forEach(updatePrice);
    };
    const categoryLinks = Array.from(page.querySelectorAll('[data-tt-category-link]'));
    const destinations = Array.from(new Set(categoryLinks.map(link => link.hash))).map(hash => document.getElementById(hash.slice(1))).filter(Boolean);
    let navigationFrame;
    const updateCategory = () => {
      navigationFrame = undefined;
      let current = destinations[0];
      destinations.forEach(section => { if (section.getBoundingClientRect().top <= window.innerHeight * .4) current = section; });
      categoryLinks.forEach(link => {
        if (current && link.hash === '#' + current.id) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };
    window.addEventListener('scroll', () => { if (!navigationFrame) navigationFrame = requestAnimationFrame(updateCategory); }, {signal:lifetime.signal, passive:true});
    updateCategory();
    const bonus = page.querySelector('[data-tt-bonus]');
    const banner = page.querySelector('[data-tt-timed-banner]');
    let syncBonus = () => {};
    let stopBonus = () => {};
    if (offer && !returning) {
      const cookieName = 'dg_tt_offer_v2';
      const bonusCode = bonus?.dataset.code;
      const remember = 30 * 86400000;
      let state;
      let timer;
      let bonusOpener;
      const readState = () => {
        try {
          const raw = document.cookie.split('; ').find(value => value.startsWith(cookieName + '='));
          if (!raw) return null;
          const value = JSON.parse(decodeURIComponent(raw.slice(cookieName.length + 1)));
          if (value.code !== baseCode || !Number.isFinite(value.started) || !Number.isFinite(value.deadline) || !Number.isFinite(value.until) || value.deadline !== value.started + 1200000 || value.until <= Date.now() || typeof value.claimed !== 'boolean' || typeof value.exitShown !== 'boolean') return null;
          return value;
        } catch { return null; }
      };
      const saveState = value => {
        try {
          document.cookie = cookieName + '=' + encodeURIComponent(JSON.stringify(value)) + '; Path=/; SameSite=Lax; Max-Age=' + Math.max(1, Math.floor((value.until - Date.now()) / 1000)) + (location.protocol === 'https:' ? '; Secure' : '');
          const saved = readState();
          if (!saved || saved.started !== value.started || saved.claimed !== value.claimed || saved.exitShown !== value.exitShown) return false;
          state = saved; return true;
        } catch { return false; }
      };
      state = readState();
      if (!state) {
        const now = Date.now();
        saveState({code:baseCode, started:now, deadline:now + 1200000, until:now + remember, claimed:false, exitShown:false, bonusCode:null});
      }
      syncBonus = () => {
        state = readState();
        const claimed = Boolean(state?.claimed && bonus && state.bonusCode === bonusCode);
        const expired = Boolean(banner && state && Date.now() >= state.deadline);
        applyOffer(claimed ? 40 : expired ? 0 : 30, claimed ? bonusCode : expired ? '' : baseCode);
        if (banner) {
          banner.hidden = !state || claimed;
          banner.classList.toggle('is-expired', expired);
          const seconds = Math.max(0, Math.ceil(((state?.deadline || Date.now()) - Date.now()) / 1000));
          banner.querySelector('[data-tt-offer-clock]').textContent = String(Math.floor(seconds / 60)).padStart(2,'0') + ':' + String(seconds % 60).padStart(2,'0');
          if (expired) {
            banner.querySelector('[data-tt-timed-heading]').textContent = labels.timed_expired_heading;
            banner.querySelector('[data-tt-timed-detail]').textContent = labels.timed_expired_detail;
            banner.querySelector('[data-tt-timed-cta]').textContent = labels.keep_shopping;
          }
        }
        if (claimed && bonus.open) bonus.close();
        if (!state || expired || claimed) { clearInterval(timer); timer = undefined; }
      };
      const startClock = () => { if (banner && !timer && state && !state.claimed && state.deadline > Date.now()) timer = setInterval(syncBonus, 1000); };
      window.addEventListener('focus', () => { syncBonus(); startClock(); }, {signal:lifetime.signal});
      document.addEventListener('visibilitychange', () => { if (!document.hidden) { syncBonus(); startClock(); } }, {signal:lifetime.signal});
      stopBonus = () => { clearInterval(timer); if (bonus?.open) bonus.close(); };
      syncBonus(); startClock();
      if (bonus) {
        const errorNode = bonus.querySelector('[data-tt-bonus-error]');
        const closeBonus = () => { bonus.close(); if (bonusOpener?.isConnected) bonusOpener.focus(); };
        const showBonus = () => {
          syncBonus();
          if (!state || state.exitShown || state.claimed || busy || leaving || document.hidden || document.querySelector('dialog[open]') || window.Shopify?.designMode || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]')) return;
          if (!saveState({...state, exitShown:true, bonusCode})) return;
          bonusOpener = document.activeElement;
          showError(errorNode,''); bonus.showModal();
        };
        page.addEventListener('click', event => {
          if (event.target.closest('[data-tt-close-bonus]')) closeBonus();
          if (event.target.closest('[data-tt-claim-bonus]')) {
            syncBonus();
            if (!state || state.claimed || !state.exitShown || !bonus.open) return;
            if (!saveState({...state, claimed:true, bonusCode})) { showError(errorNode,labels.bonus_storage_error); return; }
            syncBonus(); closeBonus(); toast(labels.bonus_saved);
          }
        }, {signal:lifetime.signal});
        bonus.addEventListener('click', event => {
          if (event.target !== bonus) return;
          const box = bonus.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeBonus();
        }, {signal:lifetime.signal});
        const entered = Date.now();
        let engaged = false;
        let peakScroll = window.scrollY;
        let lastScroll = window.scrollY;
        let upward = 0;
        page.addEventListener('pointerdown', () => { engaged = true; }, {signal:lifetime.signal, passive:true});
        document.addEventListener('mouseout', event => {
          if (bonus.dataset.exit === 'true' && matchMedia('(hover: hover) and (pointer: fine)').matches && !event.relatedTarget && event.clientY <= 8 && engaged && Date.now() - entered >= 12000) showBonus();
        }, {signal:lifetime.signal});
        window.addEventListener('scroll', () => {
          const y = Math.max(0,window.scrollY);
          if (Math.abs(y - lastScroll) > 10) engaged = true;
          peakScroll = Math.max(peakScroll,y);
          upward = y < lastScroll ? upward + lastScroll - y : 0;
          lastScroll = y;
          if (bonus.dataset.mobile === 'true' && matchMedia('(pointer: coarse)').matches && Date.now() - entered >= 45000 && peakScroll >= window.innerHeight * .75 && upward >= 160) showBonus();
        }, {signal:lifetime.signal, passive:true});
      }
    }
    const api = async (path, body) => {
      const response = await fetch(root + path, {method: body ? 'POST' : 'GET', credentials:'same-origin', headers:{'Accept':'application/json', ...(body ? {'Content-Type':'application/json'} : {})}, ...(body ? {body:JSON.stringify(body)} : {})});
      let data;
      try { data = await response.json(); } catch { throw new Error(labels.error); }
      if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : labels.error);
      return data;
    };
    const element = (tag, text, className) => { const node = document.createElement(tag); if (text != null) node.textContent = text; if (className) node.className = className; return node; };
    const renderCart = (data) => {
      cart = data;
      page.querySelectorAll('[data-tt-cart-count]').forEach(node => { node.textContent = data.item_count; });
      const items = page.querySelector('[data-tt-cart-items]');
      items.replaceChildren();
      if (!data.items.length) items.append(element('p', labels.empty));
      data.items.forEach(item => {
        const row = element('div', null, 'tt-cart-item');
        if (item.image) { const image = element('img'); image.src = item.image; image.alt = item.product_title || item.title; image.width = 75; image.height = 85; row.append(image); }
        const details = element('div');
        details.append(element('h3', item.product_title || item.title));
        if (item.variant_title && item.variant_title !== 'Default Title') details.append(element('p', item.variant_title));
        details.append(element('p', labels.quantity + ': ' + item.quantity));
        details.append(element('p', format(item.final_line_price)));
        const remove = element('button', labels.remove); remove.type = 'button'; remove.dataset.ttRemove = item.key; details.append(remove);
        row.append(details); items.append(row);
      });
      page.querySelector('[data-tt-cart-subtotal]').textContent = format(data.items_subtotal_price);
      checkoutButton.disabled = data.item_count === 0;
    };
    const refreshCart = async () => { const data = await api('cart.js'); renderCart(data); return data; };
    const openCart = async () => {
      opener = document.activeElement;
      if (!cartDialog.open) cartDialog.showModal();
      showError(cartError, '');
      checkoutButton.disabled = true;
      try { await refreshCart(); } catch (error) { showError(cartError, error.message); }
    };
    const closeCart = () => { cartDialog.close(); if (opener && opener.isConnected) opener.focus(); };
    const checkoutUrl = () => offer && code ? root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'checkout') : root + 'checkout';
    const checkout = (expectedRate = percent) => {
      syncBonus();
      if (percent < expectedRate) {
        openCart().then(() => showError(cartError, labels.timed_expired_detail));
        toast(labels.timed_expired_heading);
        return;
      }
      leaving = true;
      if (percent > 0 && !loggedIn) {
        toast(labels.login);
        try { sessionStorage.setItem(pendingKey, JSON.stringify({time:Date.now(), rate:percent})); } catch {}
        const login = new URL(page.dataset.loginUrl, location.origin);
        const destination = new URL(location.href);
        destination.searchParams.set('tt_checkout', '1'); destination.hash = '';
        login.searchParams.set('return_to', destination.pathname + destination.search);
        location.assign(login.href);
        return;
      }
      location.assign(checkoutUrl());
    };
    const add = async (form, direct) => {
      if (busy) return;
      const errorNode = form.querySelector('[data-tt-form-error]');
      const id = form.elements.id.value;
      const expectedRate = percent;
      const quantity = Number(form.elements.quantity.value) || 1;
      const controls = Array.from(form.querySelectorAll('button')).map(node => [node, node.disabled]);
      busy = true; form.setAttribute('aria-busy', 'true'); showError(errorNode, '');
      controls.forEach(([node]) => { node.disabled = true; });
      const buyText = form.querySelector('[data-tt-buy-text]'); const originalText = buyText.textContent; buyText.textContent = labels.busy;
      try {
        await api('cart/add.js', {items:[{id, quantity}]});
        if (direct) checkout(expectedRate); else { await openCart(); toast(labels.added); }
      } catch (error) { showError(errorNode, error.message || labels.error); }
      finally { busy = false; form.removeAttribute('aria-busy'); controls.forEach(([node, disabled]) => { node.disabled = disabled; }); buyText.textContent = originalText; }
    };
    page.addEventListener('submit', event => {
      const form = event.target.closest('[data-tt-product-form]');
      if (!form) return;
      event.preventDefault(); add(form, form.dataset.ttSubmitAction !== 'bag');
    });
    page.addEventListener('click', async event => {
      const variant = event.target.closest('[data-tt-variant]');
      if (variant) {
        if (variant.getAttribute('aria-disabled') === 'true' || busy) return;
        const card = variant.closest('[data-tt-product]'); const form = card.querySelector('form');
        card.querySelectorAll('[data-tt-variant]').forEach(button => button.setAttribute('aria-pressed', String(button === variant)));
        form.elements.id.value = variant.dataset.ttVariant; form.elements.quantity.value = variant.dataset.minimum || '1';
        card.dataset.basePrice = variant.dataset.price;
        updatePrice(card);
        const minimum = card.querySelector('[data-tt-minimum]'); minimum.textContent = variant.dataset.minimumLabel; minimum.hidden = Number(variant.dataset.minimum || 1) <= 1;
        card.querySelectorAll('[data-tt-product-link]').forEach(link => { link.href = variant.dataset.url; });
        showError(form.querySelector('[data-tt-form-error]'), '');
        return;
      }
      const addButton = event.target.closest('[data-tt-add]'); if (addButton) { add(addButton.closest('form'), false); return; }
      if (event.target.closest('[data-tt-open-cart]')) { openCart(); return; }
      if (event.target.closest('[data-tt-close-cart]')) { closeCart(); return; }
      if (event.target.closest('[data-tt-checkout]')) {
        if (busy) return;
        const expectedRate = percent;
        busy = true; checkoutButton.disabled = true; showError(cartError, '');
        try { const data = await refreshCart(); if (data.item_count) checkout(expectedRate); }
        catch (error) { showError(cartError, error.message); }
        finally { busy = false; checkoutButton.disabled = !cart || !cart.item_count; }
        return;
      }
      const remove = event.target.closest('[data-tt-remove]');
      if (remove) {
        if (busy) return;
        busy = true; remove.disabled = true; showError(cartError, '');
        try { renderCart(await api('cart/change.js', {id:remove.dataset.ttRemove, quantity:0})); }
        catch (error) { showError(cartError, error.message); remove.disabled = false; }
        finally { busy = false; }
        return;
      }
      if (event.target.closest('[data-tt-help]')) {
        if (bonus?.open) bonus.close();
        if (typeof window.Intercom === 'function') window.Intercom('show'); else location.assign(root + 'pages/contact');
      }
    });
    cartDialog.addEventListener('click', event => { if (event.target !== cartDialog) return; const box = cartDialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeCart(); });
    page.querySelectorAll('[data-tt-drag]').forEach(track => {
      let drag = null; let suppressClick = false;
      track.addEventListener('pointerdown', event => { if (event.pointerType !== 'mouse' || event.button !== 0) return; drag = {x:event.clientX, left:track.scrollLeft, id:event.pointerId, moved:false}; suppressClick = false; });
      track.addEventListener('pointermove', event => { if (!drag) return; const dx = event.clientX - drag.x; if (Math.abs(dx) > 6) { drag.moved = true; track.classList.add('is-dragging'); track.setPointerCapture(drag.id); event.preventDefault(); track.scrollLeft = drag.left - dx; } });
      const stop = () => { if (!drag) return; suppressClick = drag.moved; if (track.hasPointerCapture(drag.id)) track.releasePointerCapture(drag.id); drag = null; track.classList.remove('is-dragging'); };
      track.addEventListener('pointerup', stop); track.addEventListener('pointercancel', stop); track.addEventListener('lostpointercapture', stop);
      track.addEventListener('click', event => { if (!suppressClick) return; event.preventDefault(); event.stopPropagation(); suppressClick = false; }, true);
      track.addEventListener('dragstart', event => event.preventDefault());
    });
    const resume = async () => {
      const url = new URL(location.href); if (url.searchParams.get('tt_checkout') !== '1') return;
      url.searchParams.delete('tt_checkout'); history.replaceState(null, '', url.pathname + url.search + url.hash);
      let pending; try { pending = JSON.parse(sessionStorage.getItem(pendingKey)); sessionStorage.removeItem(pendingKey); } catch {}
      const pendingTime = typeof pending === 'number' ? pending : pending?.time;
      const pendingRate = typeof pending === 'number' ? 30 : pending?.rate;
      if (!pendingTime || Date.now() - pendingTime > 1800000) return;
      syncBonus();
      if (returning || !loggedIn || !offer || percent < pendingRate) { await openCart(); if (returning) showError(cartError, labels.returning); else if (percent < pendingRate) showError(cartError, labels.timed_expired_detail); return; }
      try { const data = await refreshCart(); if (data.item_count) checkout(); } catch (error) { await openCart(); showError(cartError, error.message); }
    };
    resume();
    window.addEventListener('pageshow', event => { if (event.persisted) location.reload(); }, {signal:lifetime.signal});
    cleanup.set(page, () => { lifetime.abort(); stopBonus(); clearTimeout(toastTimer); cancelAnimationFrame(navigationFrame); if (cartDialog.open) cartDialog.close(); initialized.delete(page); });
  };
  document.querySelectorAll('[data-tt-landing]').forEach(setup);
  document.addEventListener('shopify:section:load', event => { event.target.querySelectorAll('[data-tt-landing]').forEach(setup); });
  document.addEventListener('shopify:section:unload', event => { event.target.querySelectorAll('[data-tt-landing]').forEach(page => cleanup.get(page)?.()); });
})();
